import { render, staticRenderFns } from "./newCGprice.vue?vue&type=template&id=3ff0b7d0&scoped=true"
import script from "./newCGprice.vue?vue&type=script&lang=js"
export * from "./newCGprice.vue?vue&type=script&lang=js"
import style0 from "./newCGprice.vue?vue&type=style&index=0&id=3ff0b7d0&prod&scoped=true&lang=css"
import style1 from "./newCGprice.vue?vue&type=style&index=1&id=3ff0b7d0&prod&lang=css"
import style2 from "./newCGprice.vue?vue&type=style&index=2&id=3ff0b7d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff0b7d0",
  null
  
)

export default component.exports